module.exports = __webpack_public_path__ + "img/zhth-3.1c376812.png";